<template>
  <!-- 工单内容展示或编辑 -->
  <div ref="editableContent">
    <div class="d-flex align-items-start" v-if="!editing">
      <!--  显示    -->
      <div class="me-3">
        <div
          class="d-flex align-items-center"
          v-for="(item, index) in maintainItems"
          :key="index"
        >
          <span>{{ item.item_name }}</span>

          <el-tooltip
              class="box-item"
              effect="dark"
              placement="top"
              :teleported="false"
              v-if="item.description&&item.description.length>0"
          >
            <template #content>
              <div style="width:180px;font-size: 13px">
               {{item.description}}
              </div>
            </template>
            <i class="ri-information-line ms-1 cursor-pointer text-primary" style="font-size: 1rem;" ></i>
          </el-tooltip>
        </div>
        <div class="text-break pre-line">
          {{ form.content }}
        </div>
      </div>
      <i ref="editContentBtn" class="ri-pencil-line cursor-pointer" v-if="editable"></i>
    </div>
    <template v-else>
      <div class="content-part border rounded-2" :class="[contentError && 'box-is-invalid']">
        <div class="maintain-content border-bottom-dashed px-3 pt-2" v-show="maintainOptions.length">
          <div>{{ $t('page.maintenance-item') }}</div>
          <span class="text-muted mt-1">{{ $t('page.please-check-maintenance-item') }}</span>
          <div class="checkbox-list mt-2">
            <div class="form-check mb-2 d-flex align-items-center" v-for="(item, index) in maintainOptions" :key="index">
              <input class="form-check-input mt-0" :checked="form.maintain_items.includes(item.id)" @click="handleMaintainItemChange(item.id)" type="checkbox">
              <span class="ms-1 cursor-pointer" @click="handleMaintainItemChange(item.id)">{{ item.item_name }}</span>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  placement="top"
                  :teleported="false"
                  v-if="item.description&&item.description.length>0"
              >
                <template #content>
                  <div style="width:180px;font-size: 13px" >
                    {{item.description}}
                  </div>
                </template>
                <i class="ri-information-line ms-1 cursor-pointer text-primary" style="font-size: 1rem;"></i>
              </el-tooltip>
            </div>
          </div>
        </div>
        <textarea class="form-control border-0" v-model.trim="form.content" :placeholder="$t('page.please-enter-content')"
        @input="()=>{ showErr=true }"></textarea>
      </div>
    </template>
  </div>

</template>

<script>
import _ from 'lodash'
export default {
  components: {

  },
  props: {
    editable: {
      type: Boolean,
      default: true,
    },
    // 维保项目可选的列表
    maintainOptions: {
      type: Array,
      default: () => []
    },
    // 显示的值
    maintainItemIds: {
      type: Array,
      default: () => [],
    },
    content: {
      type: String,
      default: '',
    },
    //当天用户操作的选项类型
    editFieldName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editing: false,
      form: {
        content: '',
        maintain_items:[],
      },
      showErr: false,
    };
  },
  watch:{},
  mounted() {
    if(this.content === "-"){
        this.form.content = ''  
      }else{
        this.form.content = this.content
      }
    this.maintainUpdateFun(this.maintainItemIds)

    document.addEventListener('click', this.clickMe);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.clickMe);
  },
  computed: {
    maintainItems() {
      return this.maintainOptions.filter(item => this.maintainItemIds.includes(item.id))
    },
    contentValue() {
      if (this.content === '-') {
        return ''
      }
      return this.content
    },
    /* 校验是否填写 */ 
    contentError() {
      let reslut = false
      /* 是否是设备保养项目 */
      if(this.maintainOptions.length){
        if(!this.form.maintain_items.length){
          reslut = true
        }
      }else{
        if(!this.form.content){
          reslut = true
        }
      }

      return reslut
    },
    /* 用户判断用户正在修改工单类型或者保养名称 */ 
    isPass(){
      let reslut = false
      if( !(this.editFieldName === 'type'||this.editFieldName === 'maintain_name')||this.showErr){
        reslut = true
      }
      return reslut;
    }
  },
  methods: {
    /* 重新更新一次数据 */ 
    maintainUpdateFun(maintain_item_ids){
      this.form.maintain_items = maintain_item_ids
    },
    startEditing() {
      this.editing = true;
    },
    saveChanges() {
      //maintainOptions.length
      if (!this.form.content && !this.form.maintain_items.length) {
        // 提示内容不能为空
        this.$message.error(this.$t('page.work-order-content-required'))
        return
      }
      const result = {
        ...this.form,
        // selectedItems: this.maintainOptions.filter(item => this.form.maintain_items.includes(item.id)),
      }
      if (!result.content) {
        result.content = '-'
      }
      this.$emit('complete', result);
      this.editing = false;
      this.showErr = false; //恢复原来的状态
    },
    clickMe(event) {
      const editContentBtnRef = this.$refs.editContentBtn
      if (editContentBtnRef) {
        if (editContentBtnRef.contains(event.target)) {
          this.startEditing()
          return;
        }
      }
      if(this.showErr){
        setTimeout(()=>{
          if (this.editing && 
          !this.$refs.editableContent.contains(event.target) && 
          !this.contentError&&
          this.isPass) {
            // this.editing = false
            this.saveChanges()
          }
        },1000)
      }
    },
    // 勾选维保项目
    handleMaintainItemChange(value) {
      this.showErr = true
      this.form.maintain_items = _.xor(this.form.maintain_items, [value])
    },
  },
};
</script>
<style scoped>
.pre-line{
  white-space: pre-line;
}
</style>
